<script setup lang="ts">
withDefaults(
  defineProps<{
    full?: boolean
    fit?: boolean
  }>(),
  {
    full: false,
    fit: false,
  }
)
</script>

<template>
  <div
    class="mcd-loader-wrapper h-full"
    :class="{ 'mcd-loader-wrapper--full': full, 'mcd-loader-wrapper--fit': fit }"
  >
    <div class="mcd-loader mcd-loader--sized"></div>
  </div>
</template>
